import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import DataTable from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon from "@insite/mobius/Icon";
import File from "@insite/mobius/Icons/File";
import FileText from "@insite/mobius/Icons/FileText";
import Link from "@insite/mobius/Link/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface ProductDetailsDocumentationStyles {
    wrapper?: InjectableCss;
    documentationTittle?: InjectableCss;
    tablediv?: InjectableCss;
    dataRowCss?: InjectableCss;
    documentationContainer?: InjectableCss;
    tableContainer?: InjectableCss;
    firstTableDiv?: InjectableCss;
    tableBody?: InjectableCss;
    specificationLable?: InjectableCss;
    attributeValues?: InjectableCss;
    fileIcon?: InjectableCss;
    iconContainer?: InjectableCss;
    link?: InjectableCss;
}

export const productDetailsDocumentationStyles: ProductDetailsDocumentationStyles = {
    wrapper: {
        css: css`
            margin: 20px 0px;
        `,
    },
    documentationTittle: {
        css: css`
            box-sizing: border-box;
            display: inline-flex;
            font-weight: 600;
            color: #474747;
            font-size: 24px;
            text-transform: uppercase;
            margin-bottom: 10px;
        `,
    },
    documentationContainer: {
        css: css`
            margin: 20px 0px;
            display: flex;
            flex-direction: column;
            row-gap: 5px;
        `,
    },
    fileIcon: {
        css: css`
            margin-right: 5px;
        `,
    },
    iconContainer: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    link: {
        css: css`
            color: #0068b6;
            font-size: 14px;
            font-weight: 500;
            height: 14px;
            letter-spacing: 0;
            line-height: 17px;
        `,
    },
};

const styles = productDetailsDocumentationStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasParentProductId & HasProduct;

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => ({});

const ProductDetailsDocumentation: React.FC<Props> = ({ product }) => {
    if (!product || !product.properties) {
        return null;
    }

    const [documentation, setDocumentation] = React.useState([]);

    React.useEffect(() => {
        if (product && product.properties.grouP_ASSETS) {
            setDocumentation(JSON.parse(product.properties.grouP_ASSETS));
        }
    }, [product]);

    const filteredDocuments = documentation.filter(item => item["AssetType"] === "DOCUMENT SYNDIGO");

    return (
        <>
            {filteredDocuments.length > 0 ? (
                <StyledWrapper {...styles.wrapper} data-test-selector="productDetails_documentation">
                    <StyledWrapper {...styles.documentationContainer}>
                        <StyledWrapper>
                            <Typography {...styles.documentationTittle}>DOCUMENTATION</Typography>
                        </StyledWrapper>
                        {filteredDocuments?.map((document: any, index: number) => (
                            <StyledWrapper key={index} {...styles.iconContainer}>
                                <Icon src={File} {...styles.fileIcon}></Icon>
                                <Link href={document.AssetURI} target="_blank" {...styles.link}>
                                    {document.AssetDescription}
                                </Link>
                            </StyledWrapper>
                        ))}
                    </StyledWrapper>
                </StyledWrapper>
            ) : null}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ProductDetailsDocumentation)),
    definition: {
        displayName: "Custom Documentation",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
